/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import userApi from '../../../api/user.api';
import { getAccessTokenParsed } from '../auth/auth.service';

/**
 * Retrieves the current organization id
 * @returns {Promise<*>}
 */
export const getUserOrganizationId = async () => {
  const tokenParsed = getAccessTokenParsed();
  if (!tokenParsed) return null;

  const currentOrgId = tokenParsed?.current_org_id;
  if (currentOrgId) return currentOrgId;

  const tenantArray = tokenParsed?.tenant_id;

  const organization = await userApi.getOrganizationByName(tenantArray[0]);
  if (organization) return organization.id;

  return tenantArray[0];
};

/**
 * Returns non-current organization for the given user
 *
 * @param {*} user
 * @returns
 */
export const getOtherOrganizations = (user) => {
  const results = [];
  if (!(typeof user === 'undefined')) {
    for (let i = 0; i < user.groups.length; i += 1) {
      const group = user.groups[i];
      if (group.id !== user?.currentOrganizationId) {
        const groupName = group.type === 'INDIVIDUAL' ? group.type : group.name;
        results.push({ name: groupName, id: group.id });
      }
    }
  }
  return results;
};
